import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { EnvironmentService } from "../configs/environment.service";

@Injectable(
  {
    providedIn: 'root'
  }
)
export class Logger {

  constructor(
    private environmentService: EnvironmentService
  ) {
    Logger.isDebug = environmentService.get('isDebug');
  }

  public static isDebug: boolean = environment.debug || false;

  public static enable(): void {
    Logger.isDebug = true;
  }
  
  public static disable(): void {
    Logger.isDebug = false;
  }
  
  public static debug(...args: any): void {
    if (Logger.isDebug) {
      const stack = new Error().stack;
      const callerLine = stack ? stack.split("\n")[2] : ""; // Riferimento alla riga di chiamata
      const formattedLine = callerLine.trim().replace(/^at\s+/, '');
      console.debug(`[${formattedLine}]`, ...args);
      // console.debug(msg);
    }
  }
  
  public static info(...args: any): void {
    if (Logger.isDebug) {
      const stack = new Error().stack;
      const callerLine = stack ? stack.split("\n")[2] : ""; // Riferimento alla riga di chiamata
      const formattedLine = callerLine.trim().replace(/^at\s+/, '');
      console.info(`[${formattedLine}]`, ...args);
      // console.info(msg);
    }
  }
  
  public static log(...args: any): void {
    if (Logger.isDebug) {
      const stack = new Error().stack;
      const callerLine = stack ? stack.split("\n")[2] : ""; // Riferimento alla riga di chiamata
      const formattedLine = callerLine.trim().replace(/^at\s+/, '');

      console.log(`[${formattedLine}]`, ...args);
      // console.log(msg);
    }
  }
  
  public static warn(...args: any): void {
    if (Logger.isDebug) {
      const stack = new Error().stack;
      const callerLine = stack ? stack.split("\n")[2] : ""; // Riferimento alla riga di chiamata
      const formattedLine = callerLine.trim().replace(/^at\s+/, '');
      console.warn(`[${formattedLine}]`, ...args);
      // console.warn(msg);
    }
  }
  
  public static error(...args: any): void {
    if (Logger.isDebug) {
      const stack = new Error().stack;
      const callerLine = stack ? stack.split("\n")[2] : ""; // Riferimento alla riga di chiamata
      const formattedLine = callerLine.trim().replace(/^at\s+/, '');
      console.error(`[${formattedLine}]`, ...args);
      // console.error(msg);
    }
  }

}



